export const SET_IS_AUTHENTICATED = 'SET_IS_AUTHENTICATED';
export const SET_IS_LOADING = 'SET_IS_LOADING';
export const SET_USUARIO_PERFIL = 'SET_USUARIO_PERFIL';
export const SET_IS_PROCESS_LOADING = 'SET_IS_PROCESS_LOADING';
export const SET_RESUMEN_DIARIO_X_RUTA = 'SET_RESUMEN_DIARIO_X_RUTA';


// WEBPACK FOOTER //
// ./src/reduxstore/actions/action-types.ts